import { render } from "./VariantModal.vue?vue&type=template&id=9481d294&scoped=true"
import script from "./VariantModal.vue?vue&type=script&lang=js"
export * from "./VariantModal.vue?vue&type=script&lang=js"

import "./VariantModal.vue?vue&type=style&index=0&id=9481d294&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9481d294"]])

export default __exports__